type CodeType = '' | 'euro';

const HTMLCode = (props: {code?: CodeType}) => {
    switch(props.code) {
        case 'euro':
            return <>€</>;
        default:
            return <>&nbsp;</>;
    };
}

export default HTMLCode;
